import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const perkContents = this.element.querySelectorAll('.perk-content');

        perkContents[0].style.maxHeight = perkContents[0].scrollHeight + 'px';

        for (const trigger of this.element.querySelectorAll('.perk')) {

            trigger.addEventListener('click', () => {
                const perkId = trigger.dataset.perk;

                for (const content of perkContents) {
                    const perkContentId = content.dataset.perkcontent;

                    if (perkId === perkContentId) {

                        for (const perk of this.element.querySelectorAll('.perk')) {
                            perk.classList.remove('active');
                        }

                        if (content.style.maxHeight) {
                            content.style.maxHeight = null;
                        } else {
                            content.style.maxHeight = content.scrollHeight + 'px';
                            trigger.classList.add('active');
                        }
                        continue;
                    }

                    content.style.maxHeight = null;
                }
            })
        }
    }
}
